// extracted by mini-css-extract-plugin
module.exports = {"basicModal":"BasicModal_basicModal__1ksaz","buttonsWrapper":"BasicModal_buttonsWrapper__1n0Yo","button":"BasicModal_button__2j7ev"};